import axios, { AxiosResponse } from "axios";
import Toast from "../utils/Toast";
import { getToken, isHiringManagerUser } from "../utils/helper";

const shouldSkipSubscriptionRedirect = () => {
  if (typeof window === "undefined") return false;

  const pathname = window.location.pathname;
  const isOnSubscriptionPage =
    pathname === "/subscriptions" ||
    pathname === "/subscriptionplan" ||
    pathname === "/update-subscriptions" ||
    pathname.startsWith("/hiring-manager/subscriptions") ||
    pathname.startsWith("/hiring-manager/update-subscriptions") ||
    pathname.includes("/payment");

  return isOnSubscriptionPage || isHiringManagerUser();
};

const isSubscriptionExpiredResponse = (data) => {
  const statusMessage = data?.statusMessage || "";
  return (
    data &&
    data.success === false &&
    String(statusMessage).toLowerCase().includes("subscription expired")
  );
};

// Set up a global interceptor to catch subscription expiry and redirect
let axiosInterceptorsInitialized = false;
if (!axiosInterceptorsInitialized) {
  axios.interceptors.response.use(
    (response) => {
      try {
        const data = response?.data;

        if (
          isSubscriptionExpiredResponse(data) &&
          !shouldSkipSubscriptionRedirect()
        ) {
          const statusMessage = data?.statusMessage || "";
          Toast(
            statusMessage || "Subscription expired. Please renew to continue.",
            "error"
          );
          if (typeof window !== "undefined") {
            window.location.href = "/subscriptions";
          }
        }
      } catch (_) { }
      return response;
    },
    (error) => {
      try {
        const bodyMessage = error?.response?.data?.statusMessage || "";
        const isSubscriptionExpiredHttp = String(bodyMessage)
          .toLowerCase()
          .includes("subscription expired");

        if (isSubscriptionExpiredHttp && !shouldSkipSubscriptionRedirect()) {
          Toast(
            bodyMessage || "Subscription expired. Please renew to continue.",
            "error"
          );
          if (typeof window !== "undefined") {
            window.location.href = "/subscriptions";
          }
        }
      } catch (_) { }
      return Promise.reject(error);
    }
  );
  axiosInterceptorsInitialized = true;
}

async function makeRequest(method, url, data = {}) {
  try {
    const token = getToken();
    const response = await axios({
      method,
      url,
      data,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response;
  } catch (error) {
    Toast(
      error.response?.data?.statusMessage || "Something Went Wrong..!",
      "error"
    );
  }
}

export async function getRequest(url) {
  return makeRequest("get", url, undefined);
}

export async function postRequest(url, data) {
  return makeRequest("post", url, data);
}

export async function putRequest(url, data) {
  return makeRequest("put", url, data);
}

export async function patchRequest(url, data) {
  return makeRequest("patch", url, data);
}

export async function deleteRequest(url, data) {
  return makeRequest("delete", url, data);
}

export async function multiPartRequest(url, data) {
  try {
    const token = getToken();
    const respose = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return respose;
  } catch (error) {
    Toast(
      error.response?.data?.statusMessage || "Something Went Wrong..!",
      "error"
    );
  }
}

export async function multiPartPUTRequest(url, data) {
  const token = getToken();
  const respose = await axios.put(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return respose;
}
